import React from 'react';
import cx from 'classnames';

import styles from './InputGroup.module.scss';

export interface Props {
  children?: React.ReactNode;
  className?: Parameters<typeof cx>[0];
  legend: string | React.ReactNode;
}

export const InputGroup: React.FC<Props> = ({
  children,
  className,
  legend,
}) => (
  <fieldset className={cx(styles.fieldset, className)}>
    <legend className={cx(typeof legend === 'string' && styles.styledLegend)}>
      {legend}
    </legend>
    {children}
  </fieldset>
);

InputGroup.displayName = 'InputGroup';
export default InputGroup;
export { styles };
